module.exports = __webpack_public_path__ + "img/usgs-logo.988dbf3e.png";